import { render, staticRenderFns } from "./mensajeSistema.vue?vue&type=template&id=eacf3736&scoped=true"
import script from "./mensajeSistema.vue?vue&type=script&lang=js"
export * from "./mensajeSistema.vue?vue&type=script&lang=js"
import style0 from "./mensajeSistema.vue?vue&type=style&index=0&id=eacf3736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eacf3736",
  null
  
)

export default component.exports